jQuery(document).ready(() => {
	$('.blog-page-btn-js').on('click', function () {
		$('.news-filters__item').removeClass('active');
		$.ajax({
			url: themeVars.ajaxurl,
			type: "POST",
			data: {
				action: "filter_posts_term",
			},
			success: function (data) {
				$('.blog-page__row').html(data.posts_html);
			},
		});
	});
});



// WEBPACK FOOTER //
// ./scripts/modules/load-all-posts.js